import { AppBar } from '@mui/material'
import React from 'react'

const Footer = () => {
    return (
        <AppBar
            position="fixed"
            sx={{
                top: 'auto',
                bottom: 0,
                padding: '10px',
                backgroundColor: 'white',
            }}
        >
            {/* <a href='https://seal.starfieldtech.com/verifySeal?sealID=2lIfdayF2ZuF5RjBNPBS7KNeMevuGySHXvmbszKt6zkseBiaymnOD9d7Iy7F' target='_blank'>
        <img  src='https://seal.starfieldtech.com/images/3/en/siteseal_sf_3_h_l_m.gif'/></a> */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <p
                    style={{
                        color: 'black',
                        alignItems: 'center',
                        display: 'flex',
                        marginRight: '10px',
                    }}
                >
                    Powered By VAY NETWORK SERVICES PRIVATE LIMITED
                </p>
                <a
                    href="https://www.sisainfosec.com/certificate.php?number=41222169242889106030&type=fsaq"
                    target="_blank"
                >
                    <img
                        style={{ width: '50px' }}
                        src="https://www.vendortopay.com/Content/pci.png"
                    />
                </a>
            </div>
        </AppBar>
    )
}

export default Footer
